module.exports = __webpack_public_path__ + "img/logo.994a1e44.png";